import { defineNuxtPlugin } from '#app/nuxt'
import { LazyQRScanner, LazySimpleKeyboard, LazyThemeToggle, LazyCreateCompany, LazyCustomField, LazyEditUser, LazyWebcamDisplay, LazyWebcamCapture, LazyTairoLogo, LazyTairoLogoText, LazyTairoToaster, LazyTairoTocAnchor, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["QRScanner", LazyQRScanner],
["SimpleKeyboard", LazySimpleKeyboard],
["ThemeToggle", LazyThemeToggle],
["CreateCompany", LazyCreateCompany],
["CustomField", LazyCustomField],
["EditUser", LazyEditUser],
["WebcamDisplay", LazyWebcamDisplay],
["WebcamCapture", LazyWebcamCapture],
["TairoLogo", LazyTairoLogo],
["TairoLogoText", LazyTairoLogoText],
["TairoToaster", LazyTairoToaster],
["TairoTocAnchor", LazyTairoTocAnchor],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
